<div class="pt-6" id="topContainer">
    <div class="p-2 ">
        <h3 [ngClass]="'text-'+globals.colorTheme">
            <i class=" material-icons">credit_card</i>
            {{QuoteButtonName}}</h3>
    </div>
</div>
<mat-divider></mat-divider>
<br>
<div formcontrolname class="container">
    <mat-form-field class="full-width">
        <mat-label>Search</mat-label>
        <input matInput class="ta-quotes-search" placeholder="Search" id="nameField" [(ngModel)]="quoteSearch">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <mat-accordion>
        <mat-expansion-panel *ngFor="let quote of filterQuote(quotes)" expanded="false" >
              <mat-expansion-panel-header [collapsedHeight]="'80px'" [expandedHeight]="'80px'" (click)="getItems(quote)" [ngClass]="'ta-quotes-' + quote.CustomerDescription.toLowerCase()">
                <mat-panel-title>
                        <div>
                            <small>{{quote.BookingTimestamp | date:'MM/dd/yyyy' }} </small> <small *ngIf="quote.isExpired" style="color:red"> - Expired on {{quote.ExpiryDate | date:'MM/dd/yyyy' }}</small> <small *ngIf="!quote.isExpired"> - Expires on {{quote.ExpiryDate | date:'MM/dd/yyyy' }}</small> 
                            <br>
                            <strong>{{quote.CustomerDescription}}</strong><br>
                            <small>{{quote.Count}} Items</small><br>           
                        </div>            
                    </mat-panel-title>               
                </mat-expansion-panel-header>
            <div *ngIf="quote.items">
                <div *ngFor="let item of quote.items">
                    <mat-checkbox [checked]="item.checked" (change)="toggle(item, quote, $event)" [ngClass]="'ta-quotes-item-' + item.ProductId.toLowerCase()">
                        <strong> {{item.ProductId}} - {{item.ProductDescription}}</strong>
                    </mat-checkbox>
                    <br>
                    <div style="padding-left: 30px;">
                        Quantity : {{item.Quantity}} {{item.SellUom}} <br>
                        Price : {{item.Price | currency:'USD':'$':'1.4-4'}} <br>
                    </div>
                    <br>
                </div>
            </div>
            <strong>
                <div class="row">
                    <div class="col">
                        <span *ngIf="quote.CalTotalPrice > 0">Amount :
                            {{quote.CalTotalPrice | currency:'USD'}}</span> <br>
                        Expiration : {{quote.ExpiryDate | date:'MM/dd/yyyy' }} <br>
                        Remarks : {{quote.Remarks}}<br>
                    </div>
                    <div class="col" align="center">
                        <button mat-button class="magin_5 btn btn-warning text-white ta-quotes-edit"
                            (click)="editQuote(quote)">Edit</button>
                        <button mat-button class="mat-mdc-button-RedBackground-WhiteText btn btn-danger text-white ta-quotes-delete"
                            (click)="deleteQuote(quote)">Delete</button>
                    </div>
                </div>
            </strong>
            <div *ngIf="selectedItems.length>0">
                <button *ngIf="!HideBookingButton" mat-button [ngClass]="'ta-quotes-book magin_5 text-white btn btn-'+globals.colorTheme"
                    (click)="book(quote, 'book')">{{BookingButtonName}}</button>
                <button *ngIf="!HidePrepayButton" mat-button [ngClass]="'ta-quotes-prepay magin_5 text-white btn btn-'+globals.colorTheme"
                    (click)="book(quote, 'prepay')"> {{PrepayButtonName}} </button></div>
        </mat-expansion-panel>
    </mat-accordion>
</div>